export enum PurchaseReturnPricingOptions {
    LAST_PURCHASE_PRICE = "LAST_PURCHASE_PRICE",
    MA_COST = "MA_COST",
    PURCHASE_INVOICE_PRICE = "PURCHASE_INVOICE_PRICE",
}

export enum SalesReturnPricingOptions {
    LAST_PURCHASE_PRICE = "LAST_PURCHASE_PRICE",
    MA_COST = "MA_COST",
    SALES_INVOICE_PRICE = "SALES_INVOICE_PRICE",
}